import { SET_SNACKBAR_STATUS } from './constants';

export function setSnackbarStatus(type, title, message) {
  return { type: SET_SNACKBAR_STATUS, payload: { type, title, message } };
}
